/* eslint-disable @typescript-eslint/no-duplicate-enum-values */

import { DeviceCaptionStyle } from '../@types/window';

export enum CaptionInfoKey {
  CAPTION_BG_COLOR_KEY = 'CAPTION_BG_COLOR_KEY',
  CAPTION_BG_OPACITY_KEY = 'CAPTION_BG_OPACITY_KEY',
  CAPTION_EDGE_COLOR_KEY = 'CAPTION_EDGE_COLOR_KEY',
  CAPTION_EDGE_TYPE_KEY = 'CAPTION_EDGE_TYPE_KEY',
  CAPTION_FONT_COLOR_KEY = 'CAPTION_FONT_COLOR_KEY',
  CAPTION_FONT_OPACITY_KEY = 'CAPTION_FONT_OPACITY_KEY',
  CAPTION_FONT_SIZE_KEY = 'CAPTION_FONT_SIZE_KEY',
  CAPTION_FONT_STYLE_KEY = 'CAPTION_FONT_STYLE_KEY',
  CAPTION_MODE_KEY = 'CAPTION_MODE_KEY',
  CAPTION_ONOFF_KEY = 'CAPTION_ONOFF_KEY',
  CAPTION_STYLE_KEY = 'CAPTION_STYLE_KEY',
  CAPTION_WINDOW_COLOR_KEY = 'CAPTION_WINDOW_COLOR_KEY',
  CAPTION_WINDOW_OPACITY_KEY = 'CAPTION_WINDOW_OPACITY_KEY',
}

export enum CaptionColor {
  'CAPTION_COLOR_BLACK' = '0,0,0',
  'CAPTION_COLOR_BLUE' = '0,0,255',
  'CAPTION_COLOR_CYAN' = '0,255,255',
  'CAPTION_COLOR_DEFAULT' = '255,255,255',
  'CAPTION_COLOR_GREEN' = '0,255,0',
  'CAPTION_COLOR_MAGENTA' = '255,0,255',
  'CAPTION_COLOR_RED' = '255,0,0',
  'CAPTION_COLOR_WHITE' = '255,255,255',
  'CAPTION_COLOR_YELLOW' = '255,255,0',
}

export enum CaptionEdge {
  'CAPTION_EDGE_DEPRESSED' = '0.3rem 0.3rem 0 rgb(color)',
  'CAPTION_EDGE_DROP_SHADOWED' = '-0.5rem -0.5rem 0.5rem rgb(color)',
  'CAPTION_EDGE_NONE' = '0 rgb(color)',
  'CAPTION_EDGE_RAISED' = '-0.3rem -0.3rem 0 rgb(color)',
  'CAPTION_EDGE_UNIFORM' = `
    -0.3rem -0.3rem 0 rgb(color),
    0.3rem -0.3rem 0 rgb(color),
    -0.3rem 0.3rem 0 rgb(color),
    0.3rem 0.3rem 0 rgb(color)`,
}

export enum CaptionFontSize {
  'CAPTION_SIZE_DEFAULT' = '5rem',
  'CAPTION_SIZE_EXTRA_LARGE' = '7rem',
  'CAPTION_SIZE_LARGE' = '6rem',
  'CAPTION_SIZE_SMALL' = '4rem',
  'CAPTION_SIZE_STANDARD' = '5rem',
}

export enum CaptionFontStyle {
  'CAPTION_FONT_DEFAULT' = '',
  'CAPTION_FONT_STYLE0' = '',
  'CAPTION_FONT_STYLE1' = '"Cutive Mono",Consolas,Courier,monopace',
  'CAPTION_FONT_STYLE2' = '"Roboto Slab","Times New Roman",Times,serif',
  'CAPTION_FONT_STYLE3' = '"Courier New"',
  'CAPTION_FONT_STYLE4' = '"Open Sans",Arial,sans-serif',
  'CAPTION_FONT_STYLE5' = '"Itim","comic sans",cursive,sans-serif',
  'CAPTION_FONT_STYLE6' = '"Segoe Script",cursive',
  'CAPTION_FONT_STYLE7' = '"Alegreya Sans",sans-serif',
}

export enum CaptionOpacity {
  'CAPTION_OPACITY_DEFAULT' = '1',
  'CAPTION_OPACITY_FLASHING' = '1',
  'CAPTION_OPACITY_HIGHLY_TRANSLUCENT' = '0.25',
  'CAPTION_OPACITY_SLIGHTLY_TRANSLUCENT' = '0.75',
  'CAPTION_OPACITY_SOLID' = '1',
  'CAPTION_OPACITY_TRANSLUCENT' = '0.5',
  'CAPTION_OPACITY_TRANSPARENT' = '0',
}

export enum CaptionStyle {
  CAPTION_STYLE_BOLD = 'CAPTION_STYLE_BOLD',
  CAPTION_STYLE_DEFAULT = 'CAPTION_STYLE_DEFAULT',
  CAPTION_STYLE_ITALIC = 'CAPTION_STYLE_ITALIC',
}

export const defaultCCStyles: DeviceCaptionStyle = {
  ccBackgroundColor: 'CAPTION_COLOR_DEFAULT',
  ccBackgroundOpacity: 'CAPTION_OPACITY_DEFAULT',
  ccFontColor: 'CAPTION_COLOR_DEFAULT',
  ccFontEffect: 'CAPTION_EDGE_NONE',
  ccFontOpacity: 'CAPTION_OPACITY_DEFAULT',
  ccFontSize: 'CAPTION_SIZE_DEFAULT',
  ccFontStyle: 'CAPTION_FONT_DEFAULT',
};
